import { PythonExercise } from '../../types/python';

export const pythonExercises: PythonExercise[] = [
  {
    id: 1,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 1: Suma de Dos Números',
    description: 'Escribí una función que reciba dos números y devuelva su suma.',
    initialCode: `def suma(a, b):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Números positivos',
        input: { a: 5, b: 3 },
        expectedOutput: 8,
        description: 'Suma de 5 + 3 debe ser 8'
      },
      {
        id: 2,
        name: 'Test 2: Números negativos',
        input: { a: -5, b: -3 },
        expectedOutput: -8,
        description: 'Suma de -5 + (-3) debe ser -8'
      },
      {
        id: 3,
        name: 'Test 3: Números mixtos',
        input: { a: 10, b: -5 },
        expectedOutput: 5,
        description: 'Suma de 10 + (-5) debe ser 5'
      }
    ],
    solution: `def suma(a, b):
    return a + b`,
    difficulty: 'beginner'
  },
  {
    id: 2,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 2: Factorial de un Número',
    description: 'Escribí una función que calcule el factorial de un número entero positivo. El factorial de n es el producto de todos los enteros positivos menores o iguales a n.',
    initialCode: `def factorial(n):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Factorial de 5',
        input: { n: 5 },
        expectedOutput: 120,
        description: '5! = 5 × 4 × 3 × 2 × 1 = 120'
      },
      {
        id: 2,
        name: 'Test 2: Factorial de 0',
        input: { n: 0 },
        expectedOutput: 1,
        description: 'Por definición, 0! = 1'
      },
      {
        id: 3,
        name: 'Test 3: Factorial de 3',
        input: { n: 3 },
        expectedOutput: 6,
        description: '3! = 3 × 2 × 1 = 6'
      }
    ],
    solution: `def factorial(n):
    if n == 0 or n == 1:
        return 1
    resultado = 1
    for i in range(2, n + 1):
        resultado *= i
    return resultado`,
    difficulty: 'beginner'
  },
  {
    id: 3,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 3: Palíndromo',
    description: 'Escribí una función que determine si una cadena es un palíndromo (se lee igual de izquierda a derecha que de derecha a izquierda).',
    initialCode: `def es_palindromo(texto):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Palíndromo simple',
        input: { texto: 'ana' },
        expectedOutput: true,
        description: '"ana" es un palíndromo'
      },
      {
        id: 2,
        name: 'Test 2: No palíndromo',
        input: { texto: 'python' },
        expectedOutput: false,
        description: '"python" no es un palíndromo'
      },
      {
        id: 3,
        name: 'Test 3: Palíndromo con mayúsculas',
        input: { texto: 'AnA' },
        expectedOutput: true,
        description: '"AnA" es un palíndromo (ignorar mayúsculas)'
      }
    ],
    solution: `def es_palindromo(texto):
    texto_limpio = texto.lower().replace(' ', '')
    return texto_limpio == texto_limpio[::-1]`,
    difficulty: 'beginner'
  },
  {
    id: 4,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 4: Lista de Números Pares',
    description: 'Escribí una función que reciba una lista de números y devuelva una nueva lista solo con los números pares.',
    initialCode: `def filtrar_pares(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista mixta',
        input: { numeros: [1, 2, 3, 4, 5, 6] },
        expectedOutput: [2, 4, 6],
        description: 'Debe devolver solo los números pares'
      },
      {
        id: 2,
        name: 'Test 2: Solo impares',
        input: { numeros: [1, 3, 5, 7] },
        expectedOutput: [],
        description: 'Si no hay pares, devolver lista vacía'
      },
      {
        id: 3,
        name: 'Test 3: Lista vacía',
        input: { numeros: [] },
        expectedOutput: [],
        description: 'Lista vacía debe devolver lista vacía'
      }
    ],
    solution: `def filtrar_pares(numeros):
    return [n for n in numeros if n % 2 == 0]`,
    difficulty: 'intermediate'
  },
  {
    id: 5,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 5: Contar Palabras',
    description: 'Escribí una función que reciba un texto y devuelva un diccionario con la frecuencia de cada palabra.',
    initialCode: `def contar_palabras(texto):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Texto simple',
        input: { texto: 'hola mundo hola' },
        expectedOutput: { 'hola': 2, 'mundo': 1 },
        description: 'Debe contar la frecuencia de cada palabra'
      },
      {
        id: 2,
        name: 'Test 2: Texto con mayúsculas',
        input: { texto: 'Python python PYTHON' },
        expectedOutput: { 'python': 3 },
        description: 'Debe tratar mayúsculas y minúsculas igual'
      }
    ],
    solution: `def contar_palabras(texto):
    palabras = texto.lower().split()
    frecuencia = {}
    for palabra in palabras:
        frecuencia[palabra] = frecuencia.get(palabra, 0) + 1
    return frecuencia`,
    difficulty: 'intermediate'
  },
  {
    id: 6,
    level: 'EXAMEN',
    title: 'Ejercicio de Examen: Ordenar Lista de Números',
    description: 'Implementá una función recursiva que ordene una lista de números en orden descendente (de mayor a menor) sin usar funciones built-in como sorted(). La función debe usar recursión y comparar elementos adyacentes para intercambiarlos cuando sea necesario.',
    initialCode: `def order_numbers(numbers):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista desordenada',
        input: { numbers: [2, 34, 7, 8, 1, 0] },
        expectedOutput: [34, 8, 7, 2, 1, 0],
        description: 'Debe ordenar [2,34,7,8,1,0] en orden descendente: [34,8,7,2,1,0]'
      },
      {
        id: 2,
        name: 'Test 2: Lista ya ordenada',
        input: { numbers: [10, 8, 5, 3, 1] },
        expectedOutput: [10, 8, 5, 3, 1],
        description: 'Lista ya ordenada debe mantenerse igual'
      },
      {
        id: 3,
        name: 'Test 3: Lista con números negativos',
        input: { numbers: [-5, 10, -3, 0, 7] },
        expectedOutput: [10, 7, 0, -3, -5],
        description: 'Debe ordenar correctamente números negativos'
      },
      {
        id: 4,
        name: 'Test 4: Lista con un solo elemento',
        input: { numbers: [42] },
        expectedOutput: [42],
        description: 'Lista con un elemento debe devolver el mismo elemento'
      },
      {
        id: 5,
        name: 'Test 5: Lista con elementos duplicados',
        input: { numbers: [5, 2, 5, 1, 2] },
        expectedOutput: [5, 5, 2, 2, 1],
        description: 'Debe manejar correctamente elementos duplicados'
      }
    ],
    solution: `def order_numbers(numbers):
    sorted = False
    for index, number in enumerate(numbers):
        if index < len(numbers) - 1 and number < numbers[index + 1]:
            sorted = True
            #change positions for numbers
            numbers[index], numbers[index + 1] = numbers[index + 1], numbers[index]
    if sorted:
        return order_numbers(numbers)
    else:
        return numbers`,
    difficulty: 'advanced'
  },
  {
    id: 7,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 7: Máximo de Tres Números',
    description: 'Escribí una función que reciba tres números y devuelva el mayor de ellos.',
    initialCode: `def maximo_tres(a, b, c):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Máximo al inicio',
        input: { a: 10, b: 5, c: 3 },
        expectedOutput: 10,
        description: 'El máximo de 10, 5, 3 debe ser 10'
      },
      {
        id: 2,
        name: 'Test 2: Máximo en el medio',
        input: { a: 5, b: 15, c: 3 },
        expectedOutput: 15,
        description: 'El máximo de 5, 15, 3 debe ser 15'
      },
      {
        id: 3,
        name: 'Test 3: Máximo al final',
        input: { a: 5, b: 3, c: 20 },
        expectedOutput: 20,
        description: 'El máximo de 5, 3, 20 debe ser 20'
      },
      {
        id: 4,
        name: 'Test 4: Números iguales',
        input: { a: 5, b: 5, c: 5 },
        expectedOutput: 5,
        description: 'Si todos son iguales, devolver ese valor'
      }
    ],
    solution: `def maximo_tres(a, b, c):
    if a >= b and a >= c:
        return a
    elif b >= a and b >= c:
        return b
    else:
        return c`,
    difficulty: 'beginner'
  },
  {
    id: 8,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 8: Contar Vocales',
    description: 'Escribí una función que reciba un texto y devuelva la cantidad de vocales (a, e, i, o, u) que contiene, sin distinguir mayúsculas y minúsculas.',
    initialCode: `def contar_vocales(texto):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Texto simple',
        input: { texto: 'hola' },
        expectedOutput: 2,
        description: '"hola" tiene 2 vocales (o, a)'
      },
      {
        id: 2,
        name: 'Test 2: Con mayúsculas',
        input: { texto: 'Python' },
        expectedOutput: 1,
        description: '"Python" tiene 1 vocal (o)'
      },
      {
        id: 3,
        name: 'Test 3: Sin vocales',
        input: { texto: 'xyz' },
        expectedOutput: 0,
        description: '"xyz" no tiene vocales'
      },
      {
        id: 4,
        name: 'Test 4: Texto largo',
        input: { texto: 'programacion' },
        expectedOutput: 5,
        description: '"programacion" tiene 5 vocales'
      }
    ],
    solution: `def contar_vocales(texto):
    texto_lower = texto.lower()
    vocales = 'aeiou'
    contador = 0
    for letra in texto_lower:
        if letra in vocales:
            contador += 1
    return contador`,
    difficulty: 'beginner'
  },
  {
    id: 9,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 9: Invertir Lista',
    description: 'Escribí una función que reciba una lista y devuelva una nueva lista con los elementos en orden inverso.',
    initialCode: `def invertir_lista(lista):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista de números',
        input: { lista: [1, 2, 3, 4, 5] },
        expectedOutput: [5, 4, 3, 2, 1],
        description: 'Debe invertir [1,2,3,4,5] a [5,4,3,2,1]'
      },
      {
        id: 2,
        name: 'Test 2: Lista de strings',
        input: { lista: ['a', 'b', 'c'] },
        expectedOutput: ['c', 'b', 'a'],
        description: 'Debe invertir lista de strings'
      },
      {
        id: 3,
        name: 'Test 3: Lista vacía',
        input: { lista: [] },
        expectedOutput: [],
        description: 'Lista vacía debe devolver lista vacía'
      }
    ],
    solution: `def invertir_lista(lista):
    return lista[::-1]`,
    difficulty: 'beginner'
  },
  {
    id: 10,
    level: 'NIVEL BÁSICO',
    title: 'Ejercicio 10: Suma de Lista',
    description: 'Escribí una función que reciba una lista de números y devuelva la suma de todos sus elementos.',
    initialCode: `def suma_lista(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista positiva',
        input: { numeros: [1, 2, 3, 4, 5] },
        expectedOutput: 15,
        description: 'Suma de [1,2,3,4,5] debe ser 15'
      },
      {
        id: 2,
        name: 'Test 2: Con negativos',
        input: { numeros: [10, -5, 3, -2] },
        expectedOutput: 6,
        description: 'Suma de [10,-5,3,-2] debe ser 6'
      },
      {
        id: 3,
        name: 'Test 3: Lista vacía',
        input: { numeros: [] },
        expectedOutput: 0,
        description: 'Lista vacía debe devolver 0'
      }
    ],
    solution: `def suma_lista(numeros):
    total = 0
    for numero in numeros:
        total += numero
    return total`,
    difficulty: 'beginner'
  },
  {
    id: 11,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 11: Promedio de Lista',
    description: 'Escribí una función que reciba una lista de números y devuelva el promedio (media aritmética). Si la lista está vacía, devolver 0.',
    initialCode: `def promedio_lista(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista simple',
        input: { numeros: [1, 2, 3, 4, 5] },
        expectedOutput: 3.0,
        description: 'Promedio de [1,2,3,4,5] debe ser 3.0'
      },
      {
        id: 2,
        name: 'Test 2: Con decimales',
        input: { numeros: [10.5, 20.5, 30.5] },
        expectedOutput: 20.5,
        description: 'Promedio de [10.5,20.5,30.5] debe ser 20.5'
      },
      {
        id: 3,
        name: 'Test 3: Lista vacía',
        input: { numeros: [] },
        expectedOutput: 0,
        description: 'Lista vacía debe devolver 0'
      }
    ],
    solution: `def promedio_lista(numeros):
    if len(numeros) == 0:
        return 0
    return sum(numeros) / len(numeros)`,
    difficulty: 'intermediate'
  },
  {
    id: 12,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 12: Encontrar Máximo y Mínimo',
    description: 'Escribí una función que reciba una lista de números y devuelva una tupla con el máximo y el mínimo (maximo, minimo).',
    initialCode: `def maximo_minimo(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista simple',
        input: { numeros: [5, 2, 8, 1, 9] },
        expectedOutput: [9, 1],
        description: 'Máximo y mínimo de [5,2,8,1,9] debe ser [9, 1]'
      },
      {
        id: 2,
        name: 'Test 2: Con negativos',
        input: { numeros: [-5, 10, -3, 7] },
        expectedOutput: [10, -5],
        description: 'Máximo y mínimo de [-5,10,-3,7] debe ser [10, -5]'
      },
      {
        id: 3,
        name: 'Test 3: Un solo elemento',
        input: { numeros: [42] },
        expectedOutput: [42, 42],
        description: 'Si hay un solo elemento, máximo y mínimo son iguales'
      }
    ],
    solution: `def maximo_minimo(numeros):
    if len(numeros) == 0:
        return None
    maximo = numeros[0]
    minimo = numeros[0]
    for numero in numeros:
        if numero > maximo:
            maximo = numero
        if numero < minimo:
            minimo = numero
    return [maximo, minimo]`,
    difficulty: 'intermediate'
  },
  {
    id: 13,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 13: Eliminar Duplicados',
    description: 'Escribí una función que reciba una lista y devuelva una nueva lista sin elementos duplicados, manteniendo el orden original.',
    initialCode: `def eliminar_duplicados(lista):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Con duplicados',
        input: { lista: [1, 2, 2, 3, 3, 3, 4] },
        expectedOutput: [1, 2, 3, 4],
        description: 'Debe eliminar duplicados manteniendo orden'
      },
      {
        id: 2,
        name: 'Test 2: Sin duplicados',
        input: { lista: [1, 2, 3, 4] },
        expectedOutput: [1, 2, 3, 4],
        description: 'Lista sin duplicados debe mantenerse igual'
      },
      {
        id: 3,
        name: 'Test 3: Strings',
        input: { lista: ['a', 'b', 'a', 'c', 'b'] },
        expectedOutput: ['a', 'b', 'c'],
        description: 'Debe funcionar con strings también'
      }
    ],
    solution: `def eliminar_duplicados(lista):
    resultado = []
    vistos = set()
    for elemento in lista:
        if elemento not in vistos:
            resultado.append(elemento)
            vistos.add(elemento)
    return resultado`,
    difficulty: 'intermediate'
  },
  {
    id: 14,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 14: Verificar Primo',
    description: 'Escribí una función que determine si un número es primo (solo divisible por 1 y por sí mismo).',
    initialCode: `def es_primo(n):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Número primo',
        input: { n: 7 },
        expectedOutput: true,
        description: '7 es un número primo'
      },
      {
        id: 2,
        name: 'Test 2: No primo',
        input: { n: 10 },
        expectedOutput: false,
        description: '10 no es primo (divisible por 2 y 5)'
      },
      {
        id: 3,
        name: 'Test 3: Casos especiales',
        input: { n: 1 },
        expectedOutput: false,
        description: '1 no se considera primo'
      },
      {
        id: 4,
        name: 'Test 4: Número primo pequeño',
        input: { n: 2 },
        expectedOutput: true,
        description: '2 es el único primo par'
      }
    ],
    solution: `def es_primo(n):
    if n < 2:
        return False
    if n == 2:
        return True
    if n % 2 == 0:
        return False
    for i in range(3, int(n ** 0.5) + 1, 2):
        if n % i == 0:
            return False
    return True`,
    difficulty: 'intermediate'
  },
  {
    id: 15,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 15: Capitalizar Palabras',
    description: 'Escribí una función que reciba un texto y devuelva el mismo texto con la primera letra de cada palabra en mayúscula y el resto en minúscula.',
    initialCode: `def capitalizar_palabras(texto):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Texto simple',
        input: { texto: 'hola mundo' },
        expectedOutput: 'Hola Mundo',
        description: '"hola mundo" debe ser "Hola Mundo"'
      },
      {
        id: 2,
        name: 'Test 2: Todo mayúsculas',
        input: { texto: 'PYTHON PROGRAMACION' },
        expectedOutput: 'Python Programacion',
        description: 'Debe convertir a formato título'
      },
      {
        id: 3,
        name: 'Test 3: Texto mixto',
        input: { texto: 'hOlA mUnDo' },
        expectedOutput: 'Hola Mundo',
        description: 'Debe normalizar todo a formato título'
      }
    ],
    solution: `def capitalizar_palabras(texto):
    palabras = texto.split()
    resultado = []
    for palabra in palabras:
        if palabra:
            resultado.append(palabra[0].upper() + palabra[1:].lower())
        else:
            resultado.append('')
    return ' '.join(resultado)`,
    difficulty: 'intermediate'
  },
  {
    id: 16,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 16: Buscar en Lista',
    description: 'Escribí una función que reciba una lista y un elemento, y devuelva el índice de la primera ocurrencia del elemento. Si no se encuentra, devolver -1.',
    initialCode: `def buscar_elemento(lista, elemento):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Elemento encontrado',
        input: { lista: [1, 2, 3, 4, 5], elemento: 3 },
        expectedOutput: 2,
        description: 'El índice de 3 en [1,2,3,4,5] es 2'
      },
      {
        id: 2,
        name: 'Test 2: Elemento no encontrado',
        input: { lista: [1, 2, 3, 4, 5], elemento: 10 },
        expectedOutput: -1,
        description: 'Si no se encuentra, devolver -1'
      },
      {
        id: 3,
        name: 'Test 3: Primera ocurrencia',
        input: { lista: [1, 2, 2, 3, 2], elemento: 2 },
        expectedOutput: 1,
        description: 'Debe devolver el índice de la primera ocurrencia'
      }
    ],
    solution: `def buscar_elemento(lista, elemento):
    for i in range(len(lista)):
        if lista[i] == elemento:
            return i
    return -1`,
    difficulty: 'intermediate'
  },
  {
    id: 17,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 17: Multiplicar Lista',
    description: 'Escribí una función que reciba una lista de números y devuelva el producto de todos sus elementos.',
    initialCode: `def multiplicar_lista(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista simple',
        input: { numeros: [1, 2, 3, 4] },
        expectedOutput: 24,
        description: 'Producto de [1,2,3,4] debe ser 24'
      },
      {
        id: 2,
        name: 'Test 2: Con ceros',
        input: { numeros: [5, 0, 3] },
        expectedOutput: 0,
        description: 'Si hay un cero, el producto es 0'
      },
      {
        id: 3,
        name: 'Test 3: Lista vacía',
        input: { numeros: [] },
        expectedOutput: 1,
        description: 'Lista vacía debe devolver 1 (elemento neutro)'
      }
    ],
    solution: `def multiplicar_lista(numeros):
    producto = 1
    for numero in numeros:
        producto *= numero
    return producto`,
    difficulty: 'intermediate'
  },
  {
    id: 18,
    level: 'NIVEL INTERMEDIO',
    title: 'Ejercicio 18: Ordenar Lista',
    description: 'Escribí una función que reciba una lista de números y devuelva una nueva lista ordenada de menor a mayor, sin usar la función sorted() ni sort().',
    initialCode: `def ordenar_lista(numeros):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Lista desordenada',
        input: { numeros: [5, 2, 8, 1, 9] },
        expectedOutput: [1, 2, 5, 8, 9],
        description: 'Debe ordenar [5,2,8,1,9] a [1,2,5,8,9]'
      },
      {
        id: 2,
        name: 'Test 2: Con negativos',
        input: { numeros: [-5, 10, -3, 7] },
        expectedOutput: [-5, -3, 7, 10],
        description: 'Debe ordenar correctamente números negativos'
      },
      {
        id: 3,
        name: 'Test 3: Lista ya ordenada',
        input: { numeros: [1, 2, 3, 4] },
        expectedOutput: [1, 2, 3, 4],
        description: 'Lista ya ordenada debe mantenerse igual'
      }
    ],
    solution: `def ordenar_lista(numeros):
    resultado = numeros.copy()
    n = len(resultado)
    for i in range(n):
        for j in range(0, n - i - 1):
            if resultado[j] > resultado[j + 1]:
                resultado[j], resultado[j + 1] = resultado[j + 1], resultado[j]
    return resultado`,
    difficulty: 'intermediate'
  },
  {
    id: 19,
    level: 'NIVEL AVANZADO',
    title: 'Ejercicio 19: Fibonacci',
    description: 'Escribí una función que reciba un número n y devuelva el n-ésimo número de la secuencia de Fibonacci. La secuencia empieza con 0, 1, 1, 2, 3, 5, 8...',
    initialCode: `def fibonacci(n):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Primeros números',
        input: { n: 0 },
        expectedOutput: 0,
        description: 'fibonacci(0) debe ser 0'
      },
      {
        id: 2,
        name: 'Test 2: Segundo número',
        input: { n: 1 },
        expectedOutput: 1,
        description: 'fibonacci(1) debe ser 1'
      },
      {
        id: 3,
        name: 'Test 3: Número mayor',
        input: { n: 7 },
        expectedOutput: 13,
        description: 'fibonacci(7) debe ser 13'
      },
      {
        id: 4,
        name: 'Test 4: Número 10',
        input: { n: 10 },
        expectedOutput: 55,
        description: 'fibonacci(10) debe ser 55'
      }
    ],
    solution: `def fibonacci(n):
    if n == 0:
        return 0
    elif n == 1:
        return 1
    else:
        a, b = 0, 1
        for i in range(2, n + 1):
            a, b = b, a + b
        return b`,
    difficulty: 'advanced'
  },
  {
    id: 20,
    level: 'NIVEL AVANZADO',
    title: 'Ejercicio 20: Anagramas',
    description: 'Escribí una función que determine si dos palabras son anagramas (contienen las mismas letras en diferente orden).',
    initialCode: `def son_anagramas(palabra1, palabra2):
    # Tu código aquí
    pass`,
    testCases: [
      {
        id: 1,
        name: 'Test 1: Anagramas simples',
        input: { palabra1: 'roma', palabra2: 'amor' },
        expectedOutput: true,
        description: '"roma" y "amor" son anagramas'
      },
      {
        id: 2,
        name: 'Test 2: No anagramas',
        input: { palabra1: 'python', palabra2: 'java' },
        expectedOutput: false,
        description: '"python" y "java" no son anagramas'
      },
      {
        id: 3,
        name: 'Test 3: Con mayúsculas',
        input: { palabra1: 'Listen', palabra2: 'Silent' },
        expectedOutput: true,
        description: 'Debe ignorar mayúsculas/minúsculas'
      }
    ],
    solution: `def son_anagramas(palabra1, palabra2):
    palabra1_limpia = palabra1.lower().replace(' ', '')
    palabra2_limpia = palabra2.lower().replace(' ', '')
    if len(palabra1_limpia) != len(palabra2_limpia):
        return False
    return sorted(palabra1_limpia) == sorted(palabra2_limpia)`,
    difficulty: 'advanced'
  }
];

